import React from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
const API_DOMAIN = ENV().REACT_APP_DOMAIN

const ReviewOfSubcriberUpload = ({handleSubmit, show, handleClose, report}: any) => {
  return (
    <>
      <Modal
        backdrop='static'
        onHide={handleClose}
        show={show}
        dialogClassName='modal-dialog-centered'
      >
        <div className='modal-header'>
          <h1>Review Contact Upload</h1>
          <div className='btn btn-icon btn-sm' onClick={() => {}}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body report'>
          <div className='card bg-secondary'>
            <div className='card-body '>
              <div className='row'>
                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/communication\com005.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{report?.data?.data?.totalContact}</strong>
                    </span>
                    <p className='text-muted'>Total contacts in list</p>
                  </div>
                </div>
                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen028.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{report?.data?.data?.uniqueContact}</strong>
                      <p className='text-muted'>Unique contacts in list</p>
                    </span>
                  </div>
                </div>

                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen040.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{report?.data?.data?.duplicateContact}</strong>
                    </span>
                    <p className='text-muted'>Duplicate in list</p>
                  </div>
                </div>
                <div className='col-6 summary_block'>
                  <span className='bg-white p-2 me-2 rounded'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2x mb-2'
                    />
                  </span>
                  <div className='summary_content'>
                    <span>
                      <strong>{report?.data?.data?.invalidContact}</strong>
                    </span>
                    <p className='text-muted'>Invalid Numbers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='mt-5'>
            <p className='mb-0'>
              Review contact report.{' '}
              <a
                href={`${API_DOMAIN}/${report?.data?.data?.downloadUrl}`}
                style={{
                  fontSize: 15,
                }}
              >
                Download report
              </a>
            </p>
          </div>
        </div>
        <div className='modal-footer pt-0 ms-auto me-0'>
          <Button className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn btn-primary' disabled={report?.isLoading} onClick={handleSubmit}>
            {report?.isLoading ? (
              <div className='d-flex justify-content-center align-items-center'>
                <Spinner variant='primary' animation='grow' /> Loading....
              </div>
            ) : (
              'Submit'
            )}
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default ReviewOfSubcriberUpload
